<div class="content">
  <div class="sliders-and-table">
    <span class="title">Performance Simulator</span>
    <div class="sliders">
      <span class="single-slider">
        <label for="dist-slider">Annual distribution %</label>
        <!-- <mat-slider id="dist-slider" thumbLabel [displayWith]="sliderLabel" tickInterval="0.5"
                    step="0.5" min="0" max="10" (valueChange)="distValue$.next($event)" [value]="distValue$ | async">
        </mat-slider> -->
        <span class="inner-labels">
          <span>0%</span>
          <span>10%</span>
        </span>
      </span>
      <span class="single-slider">
        <label for="app-slider">Annual property appreciation %</label>
        <!-- <mat-slider id="app-slider" thumbLabel [displayWith]="sliderLabel" tickInterval="0.5"
                    step="0.5" min="0" max="10" (valueChange)="appValue$.next($event)" [value]="appValue$ | async">
                    <input matSliderThumb #itemHeight>
        </mat-slider> -->
        <span class="inner-labels">
          <span>0%</span>
          <span>10%</span>
        </span>
      </span>
    </div>
    <terra-lp-leverage-table [irrWithLeverage]="xirrWithLeverage$ | async" [irrWithoutLeverage]="xirrWithoutLeverage$ | async"
                             [totalGainsWithLeverage]="totalGainsWithLeverage$ | async" [totalGainsWithoutLeverage]="totalGainsWithoutLeverage$ | async">
    </terra-lp-leverage-table>
  </div>

  <div class="graph">
    <terra-lp-leverage-graph [dist]="distValue$ | async" [app]="appValue$ | async" [data]="graphData$ | async">
    </terra-lp-leverage-graph>
  </div>
</div>

<div class="buttons">
  <button mat-flat-button color="primary" class="yes-button">Yes, I want leverage</button>
  <button mat-button class="no-button">No, Invest without leverage</button>
</div>
